module.exports = __webpack_public_path__ + "img/edit.8c58aa22.svg";